//Force encoding -> _Íì_ 
exports.getCities = function() {
	return[
		{	"id" : 1
			,"city" : "Acapulco"
			,"state" : "Guerrero"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 2
			,"city" : "Aguascalientes"
			,"state" : "Aguascalientes"
			,"tint" : 24
			,"sup_inf" : 26
			,"techo" : 37
			,"masivo_north" : 24
			,"masivo_east" : 27
			,"masivo_south" : 26
			,"masivo_west" : 25
			,"ligero_north" : 30
			,"ligero_east" : 33
			,"ligero_south" : 32
			,"ligero_west" : 32
			,"dome" : 22
			,"windows_north" : 23
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 3
			,"city" : "Apodaca"
			,"state" : "Nuevo Leon"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 32
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 4
			,"city" : "Arriaga"
			,"state" : "Chiapas"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 5
			,"city" : "Atlixco"
			,"state" : "Puebla"
			,"tint" : 23
			,"sup_inf" : 25
			,"techo" : 35
			,"masivo_north" : 23
			,"masivo_east" : 25
			,"masivo_south" : 24
			,"masivo_west" : 24
			,"ligero_north" : 28
			,"ligero_east" : 31
			,"ligero_south" : 30
			,"ligero_west" : 30
			,"dome" : 21
			,"windows_north" : 22
			,"windows_east" : 23
			,"windows_south" : 23
			,"windows_west" : 23
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 6
			,"city" : "Cabo San Lucas"
			,"state" : "Baja California Sur"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 32
			,"ligero_north" : 36
			,"ligero_east" : 39
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 7
			,"city" : "Campeche"
			,"state" : "Campeche"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 8
			,"city" : "Cancun"
			,"state" : "Quintana Roo"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 34
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 9
			,"city" : "Casas Grandes"
			,"state" : "Chihuahua"
			,"tint" : 25
			,"sup_inf" : 28
			,"techo" : 40
			,"masivo_north" : 27
			,"masivo_east" : 30
			,"masivo_south" : 28
			,"masivo_west" : 28
			,"ligero_north" : 32
			,"ligero_east" : 36
			,"ligero_south" : 34
			,"ligero_west" : 35
			,"dome" : 23
			,"windows_north" : 25
			,"windows_east" : 25
			,"windows_south" : 26
			,"windows_west" : 26
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 10
			,"city" : "Cd. de Mexico"
			,"state" : "D.F."
			,"tint" : 23
			,"sup_inf" : 23
			,"techo" : 33
			,"masivo_north" : 20
			,"masivo_east" : 22
			,"masivo_south" : 22
			,"masivo_west" : 21
			,"ligero_north" : 26
			,"ligero_east" : 29
			,"ligero_south" : 28
			,"ligero_west" : 28
			,"dome" : 19
			,"windows_north" : 21
			,"windows_east" : 21
			,"windows_south" : 21
			,"windows_west" : 21
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 11
			,"city" : "Cd. Del Carmen"
			,"state" : "Campeche"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 12
			,"city" : "Cd. Juarez"
			,"state" : "Chihuahua"
			,"tint" : 25
			,"sup_inf" : 29
			,"techo" : 41
			,"masivo_north" : 28
			,"masivo_east" : 31
			,"masivo_south" : 29
			,"masivo_west" : 29
			,"ligero_north" : 33
			,"ligero_east" : 37
			,"ligero_south" : 35
			,"ligero_west" : 36
			,"dome" : 24
			,"windows_north" : 25
			,"windows_east" : 26
			,"windows_south" : 27
			,"windows_west" : 27
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 13
			,"city" : "Cd. Obregon"
			,"state" : "Sonora"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 14
			,"city" : "Cd. Valles"
			,"state" : "San Luis Potosi"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 32
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 15
			,"city" : "Cd. Victoria"
			,"state" : "Tamaulipas"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 16
			,"city" : "Chetumal"
			,"state" : "Quintana Roo"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 32
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 17
			,"city" : "Chihuahua"
			,"state" : "Chihuahua"
			,"tint" : 25
			,"sup_inf" : 28
			,"techo" : 41
			,"masivo_north" : 27
			,"masivo_east" : 30
			,"masivo_south" : 29
			,"masivo_west" : 29
			,"ligero_north" : 33
			,"ligero_east" : 36
			,"ligero_south" : 35
			,"ligero_west" : 36
			,"dome" : 24
			,"windows_north" : 25
			,"windows_east" : 26
			,"windows_south" : 26
			,"windows_west" : 26
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 18
			,"city" : "Chilpancingo"
			,"state" : "Guerrero"
			,"tint" : 25
			,"sup_inf" : 27
			,"techo" : 38
			,"masivo_north" : 25
			,"masivo_east" : 28
			,"masivo_south" : 27
			,"masivo_west" : 26
			,"ligero_north" : 31
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 33
			,"dome" : 22
			,"windows_north" : 24
			,"windows_east" : 24
			,"windows_south" : 25
			,"windows_west" : 25
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 19
			,"city" : "Coatzacoalcos"
			,"state" : "Veracruz"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 32
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 20
			,"city" : "Colima"
			,"state" : "Colima"
			,"tint" : 25
			,"sup_inf" : 29
			,"techo" : 42
			,"masivo_north" : 28
			,"masivo_east" : 32
			,"masivo_south" : 30
			,"masivo_west" : 30
			,"ligero_north" : 34
			,"ligero_east" : 38
			,"ligero_south" : 36
			,"ligero_west" : 37
			,"dome" : 24
			,"windows_north" : 26
			,"windows_east" : 27
			,"windows_south" : 27
			,"windows_west" : 27
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 21
			,"city" : "Comalcalco"
			,"state" : "Tabasco"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 22
			,"city" : "Comitan"
			,"state" : "Chiapas"
			,"tint" : 23
			,"sup_inf" : 25
			,"techo" : 35
			,"masivo_north" : 22
			,"masivo_east" : 24
			,"masivo_south" : 24
			,"masivo_west" : 23
			,"ligero_north" : 28
			,"ligero_east" : 31
			,"ligero_south" : 30
			,"ligero_west" : 30
			,"dome" : 20
			,"windows_north" : 22
			,"windows_east" : 22
			,"windows_south" : 22
			,"windows_west" : 23
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 23
			,"city" : "Cordoba"
			,"state" : "Veracruz"
			,"tint" : 24
			,"sup_inf" : 27
			,"techo" : 38
			,"masivo_north" : 25
			,"masivo_east" : 28
			,"masivo_south" : 27
			,"masivo_west" : 27
			,"ligero_north" : 31
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 33
			,"dome" : 22
			,"windows_north" : 24
			,"windows_east" : 24
			,"windows_south" : 25
			,"windows_west" : 25
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 24
			,"city" : "Cozumel"
			,"state" : "Quintana Roo"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 32
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 25
			,"city" : "Cuautla"
			,"state" : "Morelos"
			,"tint" : 25
			,"sup_inf" : 29
			,"techo" : 41
			,"masivo_north" : 28
			,"masivo_east" : 31
			,"masivo_south" : 29
			,"masivo_west" : 29
			,"ligero_north" : 33
			,"ligero_east" : 37
			,"ligero_south" : 35
			,"ligero_west" : 36
			,"dome" : 24
			,"windows_north" : 25
			,"windows_east" : 26
			,"windows_south" : 26
			,"windows_west" : 27
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 26
			,"city" : "Cuernavaca"
			,"state" : "Morelos"
			,"tint" : 25
			,"sup_inf" : 27
			,"techo" : 39
			,"masivo_north" : 26
			,"masivo_east" : 28
			,"masivo_south" : 27
			,"masivo_west" : 27
			,"ligero_north" : 31
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 34
			,"dome" : 22
			,"windows_north" : 24
			,"windows_east" : 25
			,"windows_south" : 25
			,"windows_west" : 25
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 27
			,"city" : "Culiacan"
			,"state" : "Sinaloa"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 36
			,"masivo_south" : 33
			,"masivo_west" : 34
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 41
			,"dome" : 27
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 28
			,"city" : "Durango"
			,"state" : "Durango"
			,"tint" : 24
			,"sup_inf" : 26
			,"techo" : 37
			,"masivo_north" : 24
			,"masivo_east" : 27
			,"masivo_south" : 25
			,"masivo_west" : 25
			,"ligero_north" : 30
			,"ligero_east" : 33
			,"ligero_south" : 32
			,"ligero_west" : 32
			,"dome" : 22
			,"windows_north" : 23
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 29
			,"city" : "Ensenada"
			,"state" : "Baja California "
			,"tint" : 24
			,"sup_inf" : 25
			,"techo" : 35
			,"masivo_north" : 22
			,"masivo_east" : 25
			,"masivo_south" : 24
			,"masivo_west" : 23
			,"ligero_north" : 28
			,"ligero_east" : 31
			,"ligero_south" : 30
			,"ligero_west" : 30
			,"dome" : 20
			,"windows_north" : 22
			,"windows_east" : 22
			,"windows_south" : 22
			,"windows_west" : 23
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 30
			,"city" : "Fresnillo"
			,"state" : "Zacatecas"
			,"tint" : 23
			,"sup_inf" : 24
			,"techo" : 34
			,"masivo_north" : 21
			,"masivo_east" : 23
			,"masivo_south" : 23
			,"masivo_west" : 22
			,"ligero_north" : 27
			,"ligero_east" : 30
			,"ligero_south" : 29
			,"ligero_west" : 29
			,"dome" : 20
			,"windows_north" : 21
			,"windows_east" : 22
			,"windows_south" : 22
			,"windows_west" : 22
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 31
			,"city" : "Guadalajara"
			,"state" : "Jalisco"
			,"tint" : 25
			,"sup_inf" : 26
			,"techo" : 38
			,"masivo_north" : 25
			,"masivo_east" : 27
			,"masivo_south" : 26
			,"masivo_west" : 26
			,"ligero_north" : 30
			,"ligero_east" : 34
			,"ligero_south" : 32
			,"ligero_west" : 33
			,"dome" : 22
			,"windows_north" : 23
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 32
			,"city" : "Guadalupe"
			,"state" : "Nuevo Leon"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 32
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 33
			,"city" : "Guanajuato"
			,"state" : "Guanajuato"
			,"tint" : 24
			,"sup_inf" : 25
			,"techo" : 36
			,"masivo_north" : 23
			,"masivo_east" : 25
			,"masivo_south" : 24
			,"masivo_west" : 24
			,"ligero_north" : 29
			,"ligero_east" : 32
			,"ligero_south" : 31
			,"ligero_west" : 31
			,"dome" : 21
			,"windows_north" : 22
			,"windows_east" : 23
			,"windows_south" : 23
			,"windows_west" : 23
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 34
			,"city" : "Guasave "
			,"state" : "Sinaloa"
			,"tint" : 25
			,"sup_inf" : 32
			,"techo" : 47
			,"masivo_north" : 33
			,"masivo_east" : 36
			,"masivo_south" : 34
			,"masivo_west" : 34
			,"ligero_north" : 38
			,"ligero_east" : 42
			,"ligero_south" : 40
			,"ligero_west" : 41
			,"dome" : 27
			,"windows_north" : 28
			,"windows_east" : 30
			,"windows_south" : 30
			,"windows_west" : 30
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 35
			,"city" : "Guaymas"
			,"state" : "Sonora"
			,"tint" : 25
			,"sup_inf" : 32
			,"techo" : 47
			,"masivo_north" : 33
			,"masivo_east" : 37
			,"masivo_south" : 34
			,"masivo_west" : 35
			,"ligero_north" : 38
			,"ligero_east" : 42
			,"ligero_south" : 40
			,"ligero_west" : 42
			,"dome" : 27
			,"windows_north" : 29
			,"windows_east" : 30
			,"windows_south" : 30
			,"windows_west" : 30
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 36
			,"city" : "H. del Parral"
			,"state" : "Chihuahua"
			,"tint" : 25
			,"sup_inf" : 27
			,"techo" : 39
			,"masivo_north" : 26
			,"masivo_east" : 28
			,"masivo_south" : 27
			,"masivo_west" : 27
			,"ligero_north" : 31
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 34
			,"dome" : 23
			,"windows_north" : 24
			,"windows_east" : 25
			,"windows_south" : 25
			,"windows_west" : 25
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 37
			,"city" : "Hermosillo"
			,"state" : "Sonora"
			,"tint" : 25
			,"sup_inf" : 33
			,"techo" : 48
			,"masivo_north" : 34
			,"masivo_east" : 38
			,"masivo_south" : 35
			,"masivo_west" : 36
			,"ligero_north" : 39
			,"ligero_east" : 43
			,"ligero_south" : 41
			,"ligero_west" : 43
			,"dome" : 28
			,"windows_north" : 29
			,"windows_east" : 30
			,"windows_south" : 31
			,"windows_west" : 31
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 38
			,"city" : "Huejucar"
			,"state" : "Jalisco"
			,"tint" : 24
			,"sup_inf" : 26
			,"techo" : 38
			,"masivo_north" : 25
			,"masivo_east" : 27
			,"masivo_south" : 26
			,"masivo_west" : 26
			,"ligero_north" : 30
			,"ligero_east" : 34
			,"ligero_south" : 32
			,"ligero_west" : 33
			,"dome" : 22
			,"windows_north" : 23
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 39
			,"city" : "Jalapa"
			,"state" : "Veracruz"
			,"tint" : 23
			,"sup_inf" : 25
			,"techo" : 36
			,"masivo_north" : 23
			,"masivo_east" : 25
			,"masivo_south" : 24
			,"masivo_west" : 24
			,"ligero_north" : 29
			,"ligero_east" : 32
			,"ligero_south" : 31
			,"ligero_west" : 31
			,"dome" : 21
			,"windows_north" : 22
			,"windows_east" : 23
			,"windows_south" : 23
			,"windows_west" : 23
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 40
			,"city" : "La Paz"
			,"state" : "Baja California Sur"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 41
			,"city" : "Lagos de Moreno"
			,"state" : "Jalisco"
			,"tint" : 23
			,"sup_inf" : 26
			,"techo" : 37
			,"masivo_north" : 24
			,"masivo_east" : 26
			,"masivo_south" : 25
			,"masivo_west" : 25
			,"ligero_north" : 29
			,"ligero_east" : 33
			,"ligero_south" : 32
			,"ligero_west" : 32
			,"dome" : 21
			,"windows_north" : 23
			,"windows_east" : 23
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 42
			,"city" : "Lazaro Cardenas"
			,"state" : "Michoacan"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 43
			,"city" : "Leon"
			,"state" : "Guanajuato"
			,"tint" : 25
			,"sup_inf" : 27
			,"techo" : 38
			,"masivo_north" : 25
			,"masivo_east" : 28
			,"masivo_south" : 26
			,"masivo_west" : 26
			,"ligero_north" : 31
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 33
			,"dome" : 22
			,"windows_north" : 24
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 25
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 44
			,"city" : "Lerdo"
			,"state" : "Durango"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 43
			,"masivo_north" : 29
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 31
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 26
			,"windows_east" : 27
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 45
			,"city" : "Los Mochis"
			,"state" : "Sinaloa"
			,"tint" : 25
			,"sup_inf" : 32
			,"techo" : 47
			,"masivo_north" : 33
			,"masivo_east" : 36
			,"masivo_south" : 34
			,"masivo_west" : 34
			,"ligero_north" : 38
			,"ligero_east" : 42
			,"ligero_south" : 40
			,"ligero_west" : 41
			,"dome" : 27
			,"windows_north" : 28
			,"windows_east" : 30
			,"windows_south" : 30
			,"windows_west" : 30
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 46
			,"city" : "Manzanillo"
			,"state" : "Colima"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 47
			,"city" : "Matamoros"
			,"state" : "Tamaulipas"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 32
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 48
			,"city" : "Matehuala"
			,"state" : "San Luis Potosi"
			,"tint" : 25
			,"sup_inf" : 27
			,"techo" : 39
			,"masivo_north" : 25
			,"masivo_east" : 28
			,"masivo_south" : 27
			,"masivo_west" : 27
			,"ligero_north" : 31
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 34
			,"dome" : 22
			,"windows_north" : 24
			,"windows_east" : 25
			,"windows_south" : 25
			,"windows_west" : 25
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 49
			,"city" : "Mazatlan"
			,"state" : "Sinaloa"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 50
			,"city" : "Merida"
			,"state" : "Yucatan"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 44
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 32
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 29
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 51
			,"city" : "Mexicali"
			,"state" : "Baja California "
			,"tint" : 25
			,"sup_inf" : 34
			,"techo" : 50
			,"masivo_north" : 36
			,"masivo_east" : 40
			,"masivo_south" : 37
			,"masivo_west" : 38
			,"ligero_north" : 41
			,"ligero_east" : 45
			,"ligero_south" : 43
			,"ligero_west" : 45
			,"dome" : 29
			,"windows_north" : 30
			,"windows_east" : 32
			,"windows_south" : 32
			,"windows_west" : 32
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 52
			,"city" : "Monclova"
			,"state" : "Coahuila"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 53
			,"city" : "Monterrey"
			,"state" : "Nuevo Leon"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 32
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 54
			,"city" : "Morelia"
			,"state" : "Michoacan"
			,"tint" : 24
			,"sup_inf" : 25
			,"techo" : 35
			,"masivo_north" : 23
			,"masivo_east" : 25
			,"masivo_south" : 24
			,"masivo_west" : 24
			,"ligero_north" : 28
			,"ligero_east" : 31
			,"ligero_south" : 30
			,"ligero_west" : 30
			,"dome" : 21
			,"windows_north" : 22
			,"windows_east" : 23
			,"windows_south" : 23
			,"windows_west" : 23
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 55
			,"city" : "Navojoa"
			,"state" : "Sonora"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 56
			,"city" : "Nogales"
			,"state" : "Sonora"
			,"tint" : 25
			,"sup_inf" : 28
			,"techo" : 40
			,"masivo_north" : 27
			,"masivo_east" : 30
			,"masivo_south" : 28
			,"masivo_west" : 28
			,"ligero_north" : 32
			,"ligero_east" : 36
			,"ligero_south" : 35
			,"ligero_west" : 35
			,"dome" : 23
			,"windows_north" : 25
			,"windows_east" : 26
			,"windows_south" : 26
			,"windows_west" : 26
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 57
			,"city" : "Nuevo Laredo"
			,"state" : "Tamaulipas"
			,"tint" : 25
			,"sup_inf" : 32
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 36
			,"masivo_south" : 34
			,"masivo_west" : 34
			,"ligero_north" : 37
			,"ligero_east" : 42
			,"ligero_south" : 40
			,"ligero_west" : 41
			,"dome" : 27
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 30
			,"windows_west" : 30
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 58
			,"city" : "Oaxaca"
			,"state" : "Oaxaca"
			,"tint" : 24
			,"sup_inf" : 26
			,"techo" : 38
			,"masivo_north" : 25
			,"masivo_east" : 27
			,"masivo_south" : 26
			,"masivo_west" : 26
			,"ligero_north" : 30
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 33
			,"dome" : 22
			,"windows_north" : 23
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 59
			,"city" : "Ocotlan"
			,"state" : "Jalisco"
			,"tint" : 25
			,"sup_inf" : 27
			,"techo" : 38
			,"masivo_north" : 25
			,"masivo_east" : 28
			,"masivo_south" : 26
			,"masivo_west" : 26
			,"ligero_north" : 30
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 33
			,"dome" : 22
			,"windows_north" : 24
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 25
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 60
			,"city" : "Orizaba"
			,"state" : "Veracruz"
			,"tint" : 24
			,"sup_inf" : 26
			,"techo" : 37
			,"masivo_north" : 24
			,"masivo_east" : 26
			,"masivo_south" : 25
			,"masivo_west" : 25
			,"ligero_north" : 29
			,"ligero_east" : 33
			,"ligero_south" : 32
			,"ligero_west" : 32
			,"dome" : 21
			,"windows_north" : 23
			,"windows_east" : 23
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 61
			,"city" : "Pachuca"
			,"state" : "Hidalgo"
			,"tint" : 22
			,"sup_inf" : 22
			,"techo" : 31
			,"masivo_north" : 19
			,"masivo_east" : 20
			,"masivo_south" : 20
			,"masivo_west" : 20
			,"ligero_north" : 25
			,"ligero_east" : 27
			,"ligero_south" : 27
			,"ligero_west" : 26
			,"dome" : 18
			,"windows_north" : 20
			,"windows_east" : 20
			,"windows_south" : 20
			,"windows_west" : 20
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 62
			,"city" : "Piedras Negras"
			,"state" : "Coahuila"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 63
			,"city" : "Playa del Carmen"
			,"state" : "Quintana Roo"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 64
			,"city" : "Poza Rica"
			,"state" : "Veracruz"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 35
			,"masivo_south" : 32
			,"masivo_west" : 33
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 65
			,"city" : "Progreso"
			,"state" : "Yucatan"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 34
			,"masivo_south" : 31
			,"masivo_west" : 32
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 66
			,"city" : "Puebla"
			,"state" : "Puebla"
			,"tint" : 24
			,"sup_inf" : 24
			,"techo" : 34
			,"masivo_north" : 21
			,"masivo_east" : 23
			,"masivo_south" : 23
			,"masivo_west" : 22
			,"ligero_north" : 27
			,"ligero_east" : 30
			,"ligero_south" : 29
			,"ligero_west" : 29
			,"dome" : 20
			,"windows_north" : 21
			,"windows_east" : 22
			,"windows_south" : 22
			,"windows_west" : 22
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 67
			,"city" : "Puerto Vallarta"
			,"state" : "Jalisco"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 45
			,"masivo_north" : 31
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 33
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 68
			,"city" : "Queretaro"
			,"state" : "Queretaro"
			,"tint" : 24
			,"sup_inf" : 26
			,"techo" : 37
			,"masivo_north" : 24
			,"masivo_east" : 27
			,"masivo_south" : 26
			,"masivo_west" : 25
			,"ligero_north" : 30
			,"ligero_east" : 33
			,"ligero_south" : 32
			,"ligero_west" : 32
			,"dome" : 22
			,"windows_north" : 23
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 69
			,"city" : "Reynosa"
			,"state" : "Tamaulipas"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 35
			,"masivo_south" : 33
			,"masivo_west" : 34
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 40
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 70
			,"city" : "Rio Verde"
			,"state" : "San Luis Potosi"
			,"tint" : 25
			,"sup_inf" : 28
			,"techo" : 41
			,"masivo_north" : 27
			,"masivo_east" : 30
			,"masivo_south" : 29
			,"masivo_west" : 29
			,"ligero_north" : 33
			,"ligero_east" : 36
			,"ligero_south" : 35
			,"ligero_west" : 35
			,"dome" : 24
			,"windows_north" : 25
			,"windows_east" : 26
			,"windows_south" : 26
			,"windows_west" : 26
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 71
			,"city" : "Salina Cruz"
			,"state" : "Oaxaca"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 36
			,"masivo_south" : 33
			,"masivo_west" : 34
			,"ligero_north" : 37
			,"ligero_east" : 41
			,"ligero_south" : 39
			,"ligero_west" : 41
			,"dome" : 26
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 29
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 72
			,"city" : "Saltillo"
			,"state" : "Coahuila"
			,"tint" : 25
			,"sup_inf" : 27
			,"techo" : 38
			,"masivo_north" : 25
			,"masivo_east" : 28
			,"masivo_south" : 26
			,"masivo_west" : 26
			,"ligero_north" : 30
			,"ligero_east" : 34
			,"ligero_south" : 33
			,"ligero_west" : 33
			,"dome" : 22
			,"windows_north" : 24
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 25
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 73
			,"city" : "San Cristobal"
			,"state" : "Chiapas"
			,"tint" : 23
			,"sup_inf" : 22
			,"techo" : 31
			,"masivo_north" : 19
			,"masivo_east" : 20
			,"masivo_south" : 20
			,"masivo_west" : 20
			,"ligero_north" : 25
			,"ligero_east" : 27
			,"ligero_south" : 27
			,"ligero_west" : 26
			,"dome" : 18
			,"windows_north" : 20
			,"windows_east" : 20
			,"windows_south" : 20
			,"windows_west" : 20
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 74
			,"city" : "San Juan del Rio"
			,"state" : "Queretaro"
			,"tint" : 24
			,"sup_inf" : 24
			,"techo" : 34
			,"masivo_north" : 22
			,"masivo_east" : 24
			,"masivo_south" : 23
			,"masivo_west" : 23
			,"ligero_north" : 27
			,"ligero_east" : 30
			,"ligero_south" : 29
			,"ligero_west" : 29
			,"dome" : 20
			,"windows_north" : 21
			,"windows_east" : 22
			,"windows_south" : 22
			,"windows_west" : 22
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 75
			,"city" : "San Luis Potosi"
			,"state" : "San Luis Potosi"
			,"tint" : 25
			,"sup_inf" : 24
			,"techo" : 34
			,"masivo_north" : 22
			,"masivo_east" : 24
			,"masivo_south" : 23
			,"masivo_west" : 23
			,"ligero_north" : 27
			,"ligero_east" : 30
			,"ligero_south" : 30
			,"ligero_west" : 30
			,"dome" : 20
			,"windows_north" : 22
			,"windows_east" : 22
			,"windows_south" : 22
			,"windows_west" : 22
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 76
			,"city" : "San Pedro"
			,"state" : "Nuevo Leon"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 32
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 77
			,"city" : "Tampico"
			,"state" : "Tamaulipas"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 32
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 78
			,"city" : "Tapachula"
			,"state" : "Chiapas"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 44
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 32
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 79
			,"city" : "Tehuacan"
			,"state" : "Puebla"
			,"tint" : 24
			,"sup_inf" : 25
			,"techo" : 35
			,"masivo_north" : 23
			,"masivo_east" : 25
			,"masivo_south" : 24
			,"masivo_west" : 24
			,"ligero_north" : 28
			,"ligero_east" : 31
			,"ligero_south" : 31
			,"ligero_west" : 31
			,"dome" : 21
			,"windows_north" : 22
			,"windows_east" : 23
			,"windows_south" : 23
			,"windows_west" : 23
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 80
			,"city" : "Tepic"
			,"state" : "Nayarit"
			,"tint" : 24
			,"sup_inf" : 27
			,"techo" : 39
			,"masivo_north" : 26
			,"masivo_east" : 29
			,"masivo_south" : 27
			,"masivo_west" : 27
			,"ligero_north" : 31
			,"ligero_east" : 35
			,"ligero_south" : 34
			,"ligero_west" : 34
			,"dome" : 23
			,"windows_north" : 24
			,"windows_east" : 25
			,"windows_south" : 25
			,"windows_west" : 25
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 81
			,"city" : "Texcoco"
			,"state" : "Edo. De Mexico"
			,"tint" : 23
			,"sup_inf" : 23
			,"techo" : 32
			,"masivo_north" : 20
			,"masivo_east" : 22
			,"masivo_south" : 22
			,"masivo_west" : 21
			,"ligero_north" : 26
			,"ligero_east" : 29
			,"ligero_south" : 28
			,"ligero_west" : 28
			,"dome" : 19
			,"windows_north" : 21
			,"windows_east" : 21
			,"windows_south" : 21
			,"windows_west" : 21
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 82
			,"city" : "Tijuana"
			,"state" : "Baja California "
			,"tint" : 23
			,"sup_inf" : 26
			,"techo" : 37
			,"masivo_north" : 24
			,"masivo_east" : 27
			,"masivo_south" : 25
			,"masivo_west" : 25
			,"ligero_north" : 30
			,"ligero_east" : 33
			,"ligero_south" : 32
			,"ligero_west" : 32
			,"dome" : 22
			,"windows_north" : 23
			,"windows_east" : 24
			,"windows_south" : 24
			,"windows_west" : 24
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 83
			,"city" : "Tlaxcala"
			,"state" : "Tlaxcala"
			,"tint" : 23
			,"sup_inf" : 24
			,"techo" : 33
			,"masivo_north" : 21
			,"masivo_east" : 23
			,"masivo_south" : 22
			,"masivo_west" : 22
			,"ligero_north" : 27
			,"ligero_east" : 29
			,"ligero_south" : 29
			,"ligero_west" : 28
			,"dome" : 20
			,"windows_north" : 21
			,"windows_east" : 21
			,"windows_south" : 21
			,"windows_west" : 22
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 84
			,"city" : "Toluca"
			,"state" : "Edo. De Mexico"
			,"tint" : 22
			,"sup_inf" : 21
			,"techo" : 29
			,"masivo_north" : 17
			,"masivo_east" : 18
			,"masivo_south" : 18
			,"masivo_west" : 18
			,"ligero_north" : 23
			,"ligero_east" : 25
			,"ligero_south" : 25
			,"ligero_west" : 24
			,"dome" : 17
			,"windows_north" : 18
			,"windows_east" : 18
			,"windows_south" : 19
			,"windows_west" : 19
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 85
			,"city" : "Torreon"
			,"state" : "Coahuila"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 43
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 31
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 322
			,"fgs_north" : 70
			,"fgs_east" : 159
			,"fgs_south" : 131
			,"fgs_west" : 164
		},
		{	"id" : 86
			,"city" : "Tulancingo"
			,"state" : "Hidalgo"
			,"tint" : 23
			,"sup_inf" : 23
			,"techo" : 32
			,"masivo_north" : 19
			,"masivo_east" : 21
			,"masivo_south" : 21
			,"masivo_west" : 20
			,"ligero_north" : 25
			,"ligero_east" : 28
			,"ligero_south" : 27
			,"ligero_west" : 27
			,"dome" : 19
			,"windows_north" : 20
			,"windows_east" : 20
			,"windows_south" : 20
			,"windows_west" : 21
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 87
			,"city" : "Tuxpan"
			,"state" : "Veracruz"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 43
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 31
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 88
			,"city" : "Tuxtla Gutierrez"
			,"state" : "Chiapas"
			,"tint" : 25
			,"sup_inf" : 29
			,"techo" : 42
			,"masivo_north" : 29
			,"masivo_east" : 32
			,"masivo_south" : 30
			,"masivo_west" : 30
			,"ligero_north" : 34
			,"ligero_east" : 38
			,"ligero_south" : 36
			,"ligero_west" : 37
			,"dome" : 24
			,"windows_north" : 26
			,"windows_east" : 27
			,"windows_south" : 27
			,"windows_west" : 27
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 89
			,"city" : "Uruapan"
			,"state" : "Michoacan"
			,"tint" : 24
			,"sup_inf" : 25
			,"techo" : 35
			,"masivo_north" : 23
			,"masivo_east" : 25
			,"masivo_south" : 24
			,"masivo_west" : 24
			,"ligero_north" : 28
			,"ligero_east" : 31
			,"ligero_south" : 30
			,"ligero_west" : 30
			,"dome" : 21
			,"windows_north" : 22
			,"windows_east" : 23
			,"windows_south" : 23
			,"windows_west" : 23
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 90
			,"city" : "Valladolid"
			,"state" : "Yucatan"
			,"tint" : 25
			,"sup_inf" : 30
			,"techo" : 43
			,"masivo_north" : 30
			,"masivo_east" : 33
			,"masivo_south" : 31
			,"masivo_west" : 31
			,"ligero_north" : 35
			,"ligero_east" : 39
			,"ligero_south" : 37
			,"ligero_west" : 38
			,"dome" : 25
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 28
			,"fgs_dome" : 284
			,"fgs_north" : 95
			,"fgs_east" : 152
			,"fgs_south" : 119
			,"fgs_west" : 133
		},
		{	"id" : 91
			,"city" : "Veracruz"
			,"state" : "Veracruz"
			,"tint" : 25
			,"sup_inf" : 31
			,"techo" : 44
			,"masivo_north" : 31
			,"masivo_east" : 34
			,"masivo_south" : 32
			,"masivo_west" : 32
			,"ligero_north" : 36
			,"ligero_east" : 40
			,"ligero_south" : 38
			,"ligero_west" : 39
			,"dome" : 26
			,"windows_north" : 27
			,"windows_east" : 28
			,"windows_south" : 28
			,"windows_west" : 29
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 92
			,"city" : "Villahermosa"
			,"state" : "Tabasco"
			,"tint" : 25
			,"sup_inf" : 32
			,"techo" : 46
			,"masivo_north" : 32
			,"masivo_east" : 36
			,"masivo_south" : 34
			,"masivo_west" : 34
			,"ligero_north" : 38
			,"ligero_east" : 42
			,"ligero_south" : 40
			,"ligero_west" : 41
			,"dome" : 27
			,"windows_north" : 28
			,"windows_east" : 29
			,"windows_south" : 30
			,"windows_west" : 30
			,"fgs_dome" : 272
			,"fgs_north" : 102
			,"fgs_east" : 140
			,"fgs_south" : 114
			,"fgs_west" : 134
		},
		{	"id" : 93
			,"city" : "Zacatecas"
			,"state" : "Zacatecas"
			,"tint" : 22
			,"sup_inf" : 24
			,"techo" : 34
			,"masivo_north" : 21
			,"masivo_east" : 23
			,"masivo_south" : 23
			,"masivo_west" : 22
			,"ligero_north" : 27
			,"ligero_east" : 30
			,"ligero_south" : 29
			,"ligero_west" : 29
			,"dome" : 20
			,"windows_north" : 21
			,"windows_east" : 22
			,"windows_south" : 22
			,"windows_west" : 22
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		},
		{	"id" : 94
			,"city" : "Zihuatanejo"
			,"state" : "Guerrero"
			,"tint" : 25
			,"sup_inf" : 29
			,"techo" : 42
			,"masivo_north" : 29
			,"masivo_east" : 32
			,"masivo_south" : 30
			,"masivo_west" : 30
			,"ligero_north" : 34
			,"ligero_east" : 38
			,"ligero_south" : 36
			,"ligero_west" : 37
			,"dome" : 25
			,"windows_north" : 26
			,"windows_east" : 27
			,"windows_south" : 27
			,"windows_west" : 27
			,"fgs_dome" : 274
			,"fgs_north" : 91
			,"fgs_east" : 137
			,"fgs_south" : 118
			,"fgs_west" : 146
		}
	];
}
